import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaLakeApi = createApi({
    reducerPath: "core/measurement/lake",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementLakeList"],
    endpoints: (builder) =>({
        measurementLakeFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementLakeList'],
            query: (query = '') => ({
                url: "core/measurement/lake" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementLakeCreate: builder.mutation({
            invalidatesTags: ['measurementLakeList'],
            query: (data)=>({url: "core/measurement/lake", method: "POST", data})
        }),
        measurementLakeUpdate: builder.mutation({
            invalidatesTags: ['measurementLakeList'],
            query: (data)=>({url: "/core/measurement/lake/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        measurementLakeDelete: builder.mutation({
            invalidatesTags: ['measurementLakeList'],
            query: (id)=>({url: "/core/measurement/lake/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementLakeFindAllQuery, useMeasurementLakeCreateMutation, useMeasurementLakeUpdateMutation, useMeasurementLakeDeleteMutation } = meaLakeApi;
export {meaLakeApi};
